import React, { Fragment } from 'react';
import { Button, Card, CardHeader, CardBody, Row, Col } from 'reactstrap';
import { PRODUCT_GROUPS } from '../../../../config/constants';
import {
  calculatePriceWithoutVat,
  calculateTotalPriceOnCustomOrder,
  calculateVatValue,
  getOrderTypeByValue
} from '../../../../helpers/general';
import { FormattedMessage } from 'react-intl';

function OrderSummary(props) {
  const { organization, formikProps, productGroups } = props;

  const renderSimpleProducts = () => {
    if (formikProps.values.isSimpleSignature) {
      return <Row className="summary-row no-gutters">
        <Col xs={12} sm>
          <Row
            className="no-gutters summary-value justify-content-center justify-content-sm-start">{PRODUCT_GROUPS.SIMPLE_SIGNATURE.text}</Row>
        </Col>
        <Col xs={12} sm>
          <Row
            className="no-gutters summary-value justify-content-center justify-content-sm-start">{`${formikProps.values.simpleSignaturesValue} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'}`}</Row>
        </Col>
        <Col xs={12} sm>
          <Row
            className="no-gutters summary-value justify-content-center justify-content-sm-start">{formikProps.values.simpleSignaturesNumber}</Row>
        </Col>
        <Col xs={12} sm>
          <Row
            className="no-gutters summary-value justify-content-center justify-content-sm-start">
            {`${calculatePriceWithoutVat( formikProps.values.simpleSignaturesNumber, formikProps.values.simpleSignaturesValue )} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'}`}
          </Row>
        </Col>
        <Col xs={12} sm>
          <Row
            className="no-gutters summary-value justify-content-center justify-content-sm-start">
            {`${calculateVatValue( formikProps.values.simpleSignaturesNumber, formikProps.values.simpleSignaturesValue )} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'} `}(<FormattedMessage id="messages.vat"/>)
          </Row>
        </Col>
        <Col xs={12} sm>
          <Row
            className="no-gutters summary-value justify-content-center justify-content-sm-start">{`${calculateTotalPriceOnCustomOrder( formikProps.values.simpleSignaturesNumber, formikProps.values.simpleSignaturesValue )} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'}`}
            <span className="vat-text">(<FormattedMessage
              id="components.pages.orderManagement.vat_included"/>)</span>
          </Row>
        </Col>
      </Row>
    }

    return null;
  }

  const renderQualifiedProducts = () => {
    if (formikProps.values.isQualifiedSignature) {
      return <Row className="summary-row no-gutters">
        <Col xs={12} sm>
          <Row
            className="no-gutters summary-value justify-content-center justify-content-sm-start">{PRODUCT_GROUPS.QUALIFIED_SIGNATURE.text}</Row>
        </Col>
        <Col xs={12} sm>
          <Row
            className="no-gutters summary-value justify-content-center justify-content-sm-start">{`${formikProps.values.qualifiedSignaturesValue} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'}`}</Row>
        </Col>
        <Col xs={12} sm>
          <Row
            className="no-gutters summary-value justify-content-center justify-content-sm-start">{formikProps.values.qualifiedSignaturesNumber}</Row>
        </Col>
        <Col xs={12} sm>
          <Row
            className="no-gutters summary-value justify-content-center justify-content-sm-start">
            {`${calculatePriceWithoutVat( formikProps.values.qualifiedSignaturesNumber, formikProps.values.qualifiedSignaturesValue )} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'}`}
          </Row>
        </Col>
        <Col xs={12} sm>
          <Row
            className="no-gutters summary-value justify-content-center justify-content-sm-start">
            {`${calculateVatValue( formikProps.values.qualifiedSignaturesNumber, formikProps.values.qualifiedSignaturesValue )} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'} `}(<FormattedMessage id="messages.vat"/>)
          </Row>
        </Col>
        <Col xs={12} sm>
          <Row
            className="no-gutters summary-value justify-content-center justify-content-sm-start">{`${calculateTotalPriceOnCustomOrder( formikProps.values.qualifiedSignaturesNumber, formikProps.values.qualifiedSignaturesValue )} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'}`}
            <span className="vat-text">(<FormattedMessage
              id="components.pages.orderManagement.vat_included"/>)</span>
          </Row>
        </Col>
      </Row>
    }

    return null;
  }

  const getUserWithCertificates = () => {
    return formikProps.values.usersWithCertificate.map( item => {
      return <div key={item.id}
                  className="summary-row no-gutters summary-value text-center text-sm-left">{`${item.first_name} ${item.last_name} (${item.email})`}</div>
    } );
  }

  const renderCertificates = () => {
    if (formikProps.values.isCertificate) {
      return <Fragment>
        <Row className="summary-row no-border no-gutters">
          <Col xs={12} sm>
            <Row
              className="no-gutters summary-value justify-content-center justify-content-sm-start">{PRODUCT_GROUPS.CERTIFICATE.text}</Row>
          </Col>
          <Col xs={12} sm>
            <Row
              className="no-gutters summary-value justify-content-center justify-content-sm-start">{`${formikProps.values.certificatesValue} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'}`}</Row>
          </Col>
          <Col xs={12} sm>
            <Row
              className="no-gutters summary-value justify-content-center justify-content-sm-start">{formikProps.values.certificatesNumber}</Row>
          </Col>
          <Col xs={12} sm>
            <Row
              className="no-gutters summary-value justify-content-center justify-content-sm-start">
              {`${calculatePriceWithoutVat( formikProps.values.certificatesNumber, formikProps.values.certificatesValue )} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'}`}
            </Row>
          </Col>
          <Col xs={12} sm>
            <Row
              className="no-gutters summary-value justify-content-center justify-content-sm-start">
              {`${calculateVatValue( formikProps.values.certificatesNumber, formikProps.values.certificatesValue )} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'} `}(<FormattedMessage id="messages.vat"/>)
            </Row>
          </Col>
          <Col xs={12} sm>
            <Row
              className="no-gutters summary-value justify-content-center justify-content-sm-start">{`${calculateTotalPriceOnCustomOrder( formikProps.values.certificatesNumber, formikProps.values.certificatesValue )} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'}`}
              <span className="vat-text">(<FormattedMessage
                id="components.pages.orderManagement.vat_included"/>)</span>
            </Row>
          </Col>
        </Row>
        <Row className="summary-row align-items-center no-gutters">
          <Col xs={12} sm className="summary-value text-center text-sm-left">
            <FormattedMessage
              id="components.pages.orderManagement.orderSummary.assigned_users"/>
          </Col>
          <Col>{getUserWithCertificates()}</Col>
        </Row>
      </Fragment>
    }

    return null;
  }

  const getUserWithCertificatesWithAuth = () => {
    return formikProps.values.usersWithCertificateWithAuth.map( item => {
      return <div key={item.id}
                  className="summary-row no-gutters summary-value text-center text-sm-left">{`${item.first_name} ${item.last_name} (${item.email})`}</div>
    } );
  }

  const renderCertificatesWithAuth = () => {
    if (formikProps.values.isCertificateWithAuth) {
      return <Fragment>
        <Row className="summary-row no-border no-gutters">
          <Col xs={12} sm>
            <Row
              className="no-gutters summary-value justify-content-center justify-content-sm-start">{PRODUCT_GROUPS.CERTIFICATE_WITH_AUTH.text}</Row>
          </Col>
          <Col xs={12} sm>
            <Row
              className="no-gutters summary-value justify-content-center justify-content-sm-start">{`${formikProps.values.certificatesWithAuthValue} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'}`}</Row>
          </Col>
          <Col xs={12} sm>
            <Row
              className="no-gutters summary-value justify-content-center justify-content-sm-start">{formikProps.values.certificatesWithAuthNumber}</Row>
          </Col>
          <Col xs={12} sm>
            <Row
              className="no-gutters summary-value justify-content-center justify-content-sm-start">
              {`${calculatePriceWithoutVat( formikProps.values.certificatesWithAuthNumber, formikProps.values.certificatesWithAuthValue )} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'}`}
            </Row>
          </Col>
          <Col xs={12} sm>
            <Row
              className="no-gutters summary-value justify-content-center justify-content-sm-start">
              {`${calculateVatValue( formikProps.values.certificatesWithAuthNumber, formikProps.values.certificatesWithAuthValue )} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'} `}(<FormattedMessage id="messages.vat"/>)
            </Row>
          </Col>
          <Col xs={12} sm>
            <Row
              className="no-gutters summary-value justify-content-center justify-content-sm-start">{`${calculateTotalPriceOnCustomOrder( formikProps.values.certificatesWithAuthNumber, formikProps.values.certificatesWithAuthValue )} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'}`}
              <span className="vat-text">(<FormattedMessage
                id="components.pages.orderManagement.vat_included"/>)</span>
            </Row>
          </Col>
        </Row>
        <Row className="summary-row align-items-center no-gutters">
          <Col xs={12} sm className="summary-value text-center text-sm-left">
            <FormattedMessage
              id="components.pages.orderManagement.orderSummary.assigned_users"/>
          </Col>
          <Col>{getUserWithCertificatesWithAuth()}</Col>
        </Row>
      </Fragment>
    }

    return null;
  }

  const getUserNameForPayment = (userId) => {
    let user = '';

    organization.users.forEach( item => {
      if (item.id === userId) {
        user = `${item.first_name} ${item.last_name}`;
      }
    } );

    return <span className="summary-value">{user}</span>;
  }

  return (
    <div className="create-order-summary">
      <Card>
        <CardHeader className="text-center text-sm-left">
          <FormattedMessage
            id="components.pages.orderManagement.orderSummary.title"/>
        </CardHeader>
        <CardBody>
          <div className="summary-row no-gutters text-center text-sm-left">
            <Row className="mb-2">
              <Col xs={12} sm={3}>
                <FormattedMessage
                  id="components.pages.orderManagement.orderSummary.selected_org"/>
              </Col>
              <Col xs={12} sm={9}
                   className="summary-value">{formikProps.values.companyName}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12} sm={3}>
                <FormattedMessage
                  id="fields.order_type"/>
              </Col>
              <Col xs={12} sm={9}
                   className="summary-value">{ getOrderTypeByValue(formikProps.values.type)}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12} sm={3}>
                <FormattedMessage
                  id="fields.companyCui"/>
              </Col>
              <Col xs={12} sm={9}
                   className="summary-value">{formikProps.values.companyCui}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12} sm={3}>
                <FormattedMessage
                  id="fields.companyRegistryNo"/>
              </Col>
              <Col xs={12} sm={9}
                   className="summary-value">{formikProps.values.companyRegistryNo}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12} sm={3}>
                <FormattedMessage
                  id="fields.billing_address"/>
              </Col>
              <Col xs={12} sm={9}
                   className="summary-value">
                {`${formikProps.values.companyAddressLine1} ${formikProps.values.companyAddressLine2 && formikProps.values.companyAddressLine2.length ? formikProps.values.companyAddressLine2 : ''}`}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12} sm={3}>
                <FormattedMessage
                  id="fields.billing_phone"/>
              </Col>
              <Col xs={12} sm={9}
                   className="summary-value">{formikProps.values.companyPhone}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12} sm={3}>
                <FormattedMessage
                  id="fields.billing_county"/>
              </Col>
              <Col xs={12} sm={9}
                   className="summary-value">{formikProps.values.companyCounty}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12} sm={3}>
                <FormattedMessage
                  id="fields.billing_city"/>
              </Col>
              <Col xs={12} sm={9}
                   className="summary-value">{formikProps.values.companyCity}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12} sm={3}>
                <FormattedMessage
                  id="fields.billing_country"/>
              </Col>
              <Col xs={12} sm={9}
                   className="summary-value">{formikProps.values.companyCountry}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12} sm={3}>
                <FormattedMessage
                  id="components.pages.orderManagement.orderSummary.selected_user"/>
              </Col>
              <Col xs={12} sm={9}
                   className="">{getUserNameForPayment( formikProps.values.userForPayment )}
              </Col>
            </Row>
          </div>
          <Row className="summary-row mt-3 no-gutters">
            <Col xs={12} sm className="text-center text-sm-left">
              <FormattedMessage
                id="components.pages.orderManagement.orderSummary.name"/>
            </Col>
            <Col xs={12} sm className="text-center text-sm-left">
              <FormattedMessage
                id="components.pages.orderManagement.orderSummary.unity_price"/>
            </Col>
            <Col xs={12} sm className="text-center text-sm-left">
              <FormattedMessage
                id="components.pages.orderManagement.orderSummary.quantity"/>
            </Col>
            <Col xs={12} sm className="text-center text-sm-left">
              <FormattedMessage
                id="components.pages.orderManagement.orderSummary.price_without_vat"/>
            </Col>
            <Col xs={12} sm className="text-center text-sm-left">
              <FormattedMessage
                id="components.pages.orderManagement.orderSummary.vat_value"/>
            </Col>
            <Col xs={12} sm className="text-center text-sm-left">
              <FormattedMessage
                id="components.pages.orderManagement.orderSummary.subtotal"/>
            </Col>
          </Row>
          <div>
            {renderSimpleProducts()}
            {renderQualifiedProducts()}
            {renderCertificates()}
            {renderCertificatesWithAuth()}
          </div>
          <div
            className="row justify-content-end ml-5 create-order-total-val mt-3">
            <FormattedMessage
              id="components.pages.orderManagement.selectProductGroup.simple_signatures.total"/> {props.totalOfAllPackages( props.formikProps )}
            <span className="vat-text">(<FormattedMessage
              id="components.pages.orderManagement.vat_included"/>)</span>
          </div>
        </CardBody>
      </Card>
      <Row className="justify-content-center create-order-actions create-order-summary__actions">
        <Button
          onClick={() => props.setShowForm()}
          className="btn-warning mr-3"
          color="primary"
          size="xl"
          type="submit"
        >
          <FormattedMessage
            id="messages.go_back"/>
        </Button>
        <Button
          onClick={() => props.createCustomOrder( formikProps.values )}
          className="btn-warning ml-3"
          color="primary"
          size="xl"
          type="submit"
        >
          <FormattedMessage
            id="components.pages.orderManagement.orderForm.create"/>
        </Button>
      </Row>
    </div>
  )
}

export { OrderSummary }
